/**
 * STAND-IN GATES (STAND-IN.md §7) — when a Plan or Run gate is showing, ask the room's stand-ins to pre-review it
 * (idempotent server-side: every browser may ask, ONE review runs per gate + person) and follow their
 * recommendations live (STANDIN_UPDATED naming this gate → re-read). ``gateId`` '' = no gate → nothing.
 */
import { useEffect, useRef, useState } from 'react';
import { getGateReviews, standinOp } from '@stepflow/ui-shared/services/dataPlaneApi';

export function gateBeaconHit(messages, seen, kind, gateId) {
  let hit = false;
  for (const m of messages || []) {
    if (!m || (m.eventType ?? m.type) !== 'STANDIN_UPDATED') continue;
    const id = String(m.eventId || '');
    if (!id || seen.has(id)) continue;
    seen.add(id);
    const p = m.payload || {};
    if (p.gateKind === kind && p.gateId === gateId) hit = true;
  }
  return hit;
}

export default function useGateAdvice(networkId, poolId, kind, gateId, messages) {
  const [reviews, setReviews] = useState([]);
  const keyRef = useRef('');
  const key = gateId ? `${networkId}/${poolId}/${kind}/${gateId}` : '';
  keyRef.current = key;
  const load = () => {
    if (!key) return;
    const k = key;
    getGateReviews(networkId, kind, gateId, { pool: poolId })
      .then((r) => { if (keyRef.current === k) setReviews((r && r.reviews) || []); })
      .catch(() => {});
  };
  useEffect(() => {
    setReviews([]);
    if (!key) return;
    standinOp(networkId, 'review-gate', { kind, gateId }, { pool: poolId }).catch(() => {}).finally(load);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  const seenRef = useRef(new Set());
  useEffect(() => {
    if (key && gateBeaconHit(messages, seenRef.current, kind, gateId)) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, key]);
  return reviews;
}
